<template>
  <div>
    <div class="tax-class-options">
      <div v-for="rate in rates" :key="rate.value" class="tax-class-options__option">
        <span class="radio-item">
          <input
            :id="`vat-${uid}-${rate.value}`"
            type="radio"
            :value="rate.value"
            :checked="Number(value) === rate.value"
            :disabled="disabled"
            @change="$emit('input', rate.value)"
          >
          <label :for="`vat-${uid}-${rate.value}`">{{ rate.value }}%</label>
        </span>
        <p class="tax-class-options__description">{{ vatDisplayText(rate.description) }}</p>
      </div>
    </div>
    <div class="tax-class-options__note">
      <v-icon size="24" color="#0277BD">info_outline</v-icon>
      <p>{{ vatDisplayText(note) }}</p>
    </div>
  </div>
</template>

<script>
import AdminContext from '@/admin-i18n/context'
import { EVENT_VAT_NOTE, EVENT_VAT_RATES } from '@/utils'

export default {
  name: 'tax-class-options',
  mixins: [AdminContext],
  props: {
    value: {
      type: [Number, String],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rates: EVENT_VAT_RATES,
      note: EVENT_VAT_NOTE,
    }
  },
  computed: {
    // Keeps the radio ids unique when more than one picker is on the page.
    uid() {
      return this._uid
    },
  },
  methods: {
    // Translate only authored VAT copy; keep unknown/customer values unchanged.
    vatDisplayText(value) {
      switch (value) {
      case '— for concerts, festivals, movie projections, and sports and culture events':
        return this.adminText('shellAll.vat_concerts_description', '— for concerts, festivals, movie projections, and sports and culture events')
      case '— for catering/food services and accommodation related to the event':
        return this.adminText('shellAll.vat_catering_description', '— for catering/food services and accommodation related to the event')
      case '— for other events':
        return this.adminText('shellAll.vat_other_description', '— for other events')
      case 'Note: Tax rates depend on the specific nature of your event and may vary. Please consult your accountant or the Tax Administration to confirm the correct rate before publishing your event.':
        return this.adminText('shellAll.vat_note', 'Note: Tax rates depend on the specific nature of your event and may vary. Please consult your accountant or the Tax Administration to confirm the correct rate before publishing your event.')
      default:
        return value
      }
    },
  },
}
</script>

<style scoped>
.tax-class-options {
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
}
.tax-class-options__option {
  display: flex;
  align-items: flex-start;
  gap: 0.625rem;
}
.tax-class-options__description {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  color: #666666;
  margin: 0;
}
.tax-class-options__note {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-top: 1.25rem;
  padding: 0.75rem;
  border-radius: 0.5rem;
  background: #e6f1f8;
}
.tax-class-options__note p {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.2;
  color: #0277bd;
  margin: 0;
}
.radio-item {
  display: inline-block;
  position: relative;
  padding: 0 0.375rem;
  margin: 0;
  flex: 0 0 auto;
}
.radio-item input[type='radio'] {
  display: none;
}
.radio-item label {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1.125rem;
  color: #979797;
}
.radio-item label:before {
  content: ' ';
  display: inline-block;
  position: relative;
  top: 0.313rem;
  margin: 0 0.313rem 0 0;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 0.688rem;
  border: 0.125rem solid #666666;
  background-color: transparent;
}
.radio-item input[type='radio']:checked + label:after {
  border-radius: 0.688rem;
  width: 0.75rem;
  height: 0.75rem;
  position: absolute;
  top: 0.563rem;
  left: 0.625rem;
  content: ' ';
  display: block;
  background: #0277bd;
}
</style>
